import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import type { TemplateRow } from '../lib/types';

export default function Templates() {
  const nav = useNavigate();
  const [templates, setTemplates] = useState<TemplateRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [newName, setNewName] = useState('');

  useEffect(() => {
    api.listTemplates().then(setTemplates).finally(() => setLoading(false));
  }, []);

  async function createTemplate() {
    if (!newName.trim()) return;
    setCreating(true);
    try {
      const tpl = await api.createTemplate({
        name: newName.trim(),
        template_json: JSON.stringify({ basePdf: '', schemas: [[]] }),
      });
      nav(`/templates/${tpl.id}`);
    } catch (e) {
      alert((e as Error).message);
    } finally {
      setCreating(false);
    }
  }

  async function remove(id: string, name: string) {
    if (!confirm(`Delete template "${name}"? Generations referencing it will also be removed.`)) return;
    await api.deleteTemplate(id);
    setTemplates((prev) => prev.filter((t) => t.id !== id));
  }

  if (loading) return <p className="muted">Loading…</p>;

  return (
    <div>
      <div className="card">
        <h3>Create new template</h3>
        <div className="row">
          <input
            placeholder="Template name (e.g. Sales Invoice US Letter)"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && createTemplate()}
          />
          <button onClick={createTemplate} disabled={!newName.trim() || creating}>
            {creating ? 'Creating…' : 'Create & open designer'}
          </button>
        </div>
      </div>

      {templates.length === 0 ? (
        <div className="empty">No templates yet. Create your first one above.</div>
      ) : (
        <div className="card">
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Version</th>
                <th>Active</th>
                <th>Updated</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {templates.map((t) => (
                <tr key={t.id}>
                  <td>
                    <Link to={`/templates/${t.id}`}>{t.name}</Link>
                    {t.description && <div className="muted" style={{ fontSize: 12 }}>{t.description}</div>}
                  </td>
                  <td>v{t.version}</td>
                  <td>
                    {t.is_active
                      ? <span className="pill success">active</span>
                      : <span className="pill">disabled</span>}
                  </td>
                  <td className="muted mono">{t.updated_at}</td>
                  <td style={{ textAlign: 'right' }}>
                    <button className="ghost" onClick={() => remove(t.id, t.name)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
